// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Svg from "../primitives/Svg.res.js";
import * as I18n from "../primitives/I18n.res.js";
import * as React from "react";
import * as Spinner from "../resources/feedback-indicators/Spinner.res.js";
import * as Touchable from "../primitives/Touchable.res.js";
import * as Stdlib_Option from "@rescript/runtime/lib/es6/Stdlib_Option.js";
import * as ReactDomElement from "../primitives/ReactDomElement.res.js";
import * as Stylex from "@stylexjs/stylex";
import * as Primitive_option from "@rescript/runtime/lib/es6/Primitive_option.js";
import * as JsxRuntime from "react/jsx-runtime";
function isForwardDirection(direction) {
  return direction === "Forward";
}
function ResourceListPagination$ResourceListPaginationSummary(props) {
  let itemsPerPage = props.itemsPerPage;
  let totalCount = props.totalCount;
  let currentPage = props.currentPage;
  let match = {
    className: "color-x1i7sqjx font-x1im53ij lineHeight-xuy8w9f display-x78zum5 gap-x167g77z minWidth-x5w4yej",
    "data-style-src": "wino-gc:src/core/ResourceListPagination.res.js:19"
  };
  let start = (((currentPage - 1 | 0) * itemsPerPage | 0) + 1 | 0).toString();
  let end = Math.min(currentPage * itemsPerPage | 0, totalCount).toString();
  return JsxRuntime.jsxs("span", {
    children: [start + " — " + end + I18n.t(" of ") + totalCount.toString(), props.loading ? JsxRuntime.jsx(Spinner.make, {
      size: 16
    }) : null],
    className: match.className,
    style: match.style
  });
}
let styles$1 = {
  PaginationPageButton_root: {
    "boxSizing-kB7OPa": "boxSizing-x9f619",
    "borderColor-kVAM5u": "borderColor-x1t4mavk",
    "borderRadius-kaIpWk": "borderRadius-x1sxf85j",
    "borderStyle-ksu8eU": "borderStyle-x1y0btm7",
    "borderWidth-kMzoRj": "borderWidth-xmkeg23",
    "transition-kmkexE": "transition-x1ri3u3q",
    "display-k1xSpc": "display-x78zum5",
    "height-kZKoxP": "height-x10w6t97",
    "justifyContent-kjj79g": "justifyContent-xl56j7k",
    "minWidth-k7Eaqz": "minWidth-x46jg8d",
    ":hover_backgroundColor-kGzVvX": "backgroundColor-x7tizco",
    ":hover_borderColor-kaVNsj": "borderColor-x1uctlmt",
    $$css: "wino-gc:src/core/ResourceListPagination.res.js:49"
  },
  PaginationPageButton_disabled: {
    "backgroundColor-kWkggS": "backgroundColor-x13icfbr",
    "borderColor-kVAM5u": "borderColor-xsdecx7",
    "borderStyle-ksu8eU": "borderStyle-x1y0btm7",
    "borderWidth-kMzoRj": "borderWidth-xmkeg23",
    ":hover_backgroundColor-kGzVvX": "backgroundColor-xul9yni",
    ":hover_borderColor-kaVNsj": "borderColor-xdy0v0",
    $$css: "wino-gc:src/core/ResourceListPagination.res.js:65"
  }
};
function styleProps(disabled, pressed) {
  return Stylex.props(styles$1.PaginationPageButton_root, disabled ? styles$1.PaginationPageButton_disabled : {}, {
    transform: pressed ? "scale3d(0.94, 0.94, 1)" : "initial"
  });
}
function textStyleProps(disabled) {
  return {
    0: {
      className: "color-x1qqs05d font-xhhohpu textAlign-x2b8uid alignItems-x6s0dn4 display-x78zum5 height-x5yr21d justifyContent-xl56j7k paddingInline-xfn1xvj",
      "data-style-src": "wino-gc:src/core/ResourceListPagination.res.js:75"
    },
    1: {
      className: "textAlign-x2b8uid alignItems-x6s0dn4 display-x78zum5 height-x5yr21d justifyContent-xl56j7k paddingInline-xfn1xvj color-xbp64b2 font-x1mfpbqu",
      "data-style-src": "wino-gc:src/core/ResourceListPagination.res.js:75; wino-gc:src/core/ResourceListPagination.res.js:85"
    }
  }[!!disabled << 0];
}
function ResourceListPagination$ResourceListPaginationPageButton(props) {
  let onPress = props.onPress;
  let children = props.children;
  let action = props.action;
  let totalPages = props.totalPages;
  let currentPage = props.currentPage;
  let match = React.useState(() => false);
  let setPressed = match[1];
  let buttonProps_elementType = "div";
  let buttonProps_onPressStart = param => setPressed(param => true);
  let buttonProps_onPressEnd = param => setPressed(param => false);
  let buttonProps = {
    elementType: buttonProps_elementType,
    onPressStart: buttonProps_onPressStart,
    onPressEnd: buttonProps_onPressEnd
  };
  let disabled = Stdlib_Option.mapOr(action, true, action => {
    switch (action) {
      case "PrevPrev":
        return (currentPage - 1 | 0) <= 1;
      case "First":
      case "Prev":
        return currentPage <= 1;
      case "NextNext":
        return currentPage >= (totalPages - 1 | 0);
      case "Next":
      case "Last":
        return currentPage >= totalPages;
    }
  });
  let match$1 = styleProps(disabled, match[0]);
  let match$2 = textStyleProps(disabled);
  let disabled$1 = props.loading || disabled;
  let tmp;
  if (children !== undefined) {
    tmp = children;
  } else if (action !== undefined) {
    switch (action) {
      case "First":
        tmp = 1;
        break;
      case "Prev":
        tmp = JsxRuntime.jsx(Svg.make, {
          children: JsxRuntime.jsx(Svg.Path.make, {
            d: "M13.328 15.698a.5.5 0 1 1-.712.702l-5.972-6.049a.5.5 0 0 1 .002-.704l5.972-6a.5.5 0 1 1 .708.706L7.704 10l5.624 5.697z",
            fill: "#797885"
          }),
          width: "20",
          height: "20",
          viewBox: "0 0 20 20"
        });
        break;
      case "Next":
        tmp = JsxRuntime.jsx(Svg.make, {
          children: JsxRuntime.jsx(Svg.Path.make, {
            d: "M12.268 10.048 6.644 4.35a.5.5 0 1 1 .712-.702l5.972 6.049a.5.5 0 0 1-.002.704l-5.972 6a.5.5 0 0 1-.708-.706l5.622-5.648z",
            fill: "#797885"
          }),
          width: "20",
          height: "20",
          viewBox: "0 0 20 20"
        });
        break;
      case "PrevPrev":
      case "NextNext":
        tmp = null;
        break;
      case "Last":
        tmp = totalPages;
        break;
    }
  } else {
    tmp = null;
  }
  return JsxRuntime.jsx(Touchable.make, {
    children: JsxRuntime.jsx("div", {
      children: JsxRuntime.jsx("span", {
        children: tmp,
        className: match$2.className,
        style: match$2.style
      }),
      className: match$1.className,
      style: match$1.style
    }),
    ariaProps: buttonProps,
    disabled: disabled$1,
    onPress: param => {
      if (action !== undefined) {
        return onPress(action);
      }
    }
  });
}
let make = React.memo(ResourceListPagination$ResourceListPaginationPageButton);
let styles$2 = {
  PaginationScrollToTopButton_root: {
    "boxSizing-kB7OPa": "boxSizing-x9f619",
    "borderColor-kVAM5u": "borderColor-x1t4mavk",
    "borderRadius-kaIpWk": "borderRadius-x1sxf85j",
    "borderStyle-ksu8eU": "borderStyle-x1y0btm7",
    "borderWidth-kMzoRj": "borderWidth-xmkeg23",
    "cursor-kkrTdU": "cursor-x1ypdohk",
    "transition-kmkexE": "transition-x1ri3u3q",
    "boxShadow-kGVxlE": "boxShadow-x19llk9t",
    "display-k1xSpc": "display-x78zum5",
    "height-kZKoxP": "height-x10w6t97",
    "justifyContent-kjj79g": "justifyContent-xl56j7k",
    "width-kzqmXN": "width-x1td3qas",
    ":hover_backgroundColor-kGzVvX": "backgroundColor-x7tizco",
    ":hover_borderColor-kaVNsj": "borderColor-xdy0v0",
    $$css: "wino-gc:src/core/ResourceListPagination.res.js:198"
  }
};
function styleProps$1(pressed, show) {
  return Stylex.props(styles$2.PaginationScrollToTopButton_root, {
    transform: pressed ? "scale3d(0.94, 0.94, 1)" : "initial"
  }, {
    opacity: show ? 1 : 0,
    transition: "opacity .15s ease-out"
  });
}
function ResourceListPagination$ResourceListPaginationScrollToTopButton(props) {
  let tableBodyRef = props.tableBodyRef;
  let match = React.useState(() => false);
  let setPressed = match[1];
  let match$1 = React.useState(() => false);
  let setShow = match$1[1];
  React.useLayoutEffect(() => {
    let domElement = ReactDomElement.fromRef(tableBodyRef);
    let handler = param => {
      if (domElement === undefined) {
        return;
      }
      let domElement$1 = Primitive_option.valFromOption(domElement);
      setShow(param => domElement$1.scrollTop > 15);
    };
    handler();
    Stdlib_Option.forEach(domElement, domElement => {
      domElement.addEventListener("scroll", handler);
    });
    return () => Stdlib_Option.forEach(domElement, domElement => {
      domElement.removeEventListener("scroll", handler);
    });
  }, []);
  let buttonProps_elementType = "div";
  let buttonProps_onPressStart = param => setPressed(param => true);
  let buttonProps_onPressEnd = param => setPressed(param => false);
  let buttonProps = {
    elementType: buttonProps_elementType,
    onPressStart: buttonProps_onPressStart,
    onPressEnd: buttonProps_onPressEnd
  };
  let handleButtonPress = param => {
    let domElement = ReactDomElement.fromRef(tableBodyRef);
    if (domElement !== undefined) {
      Primitive_option.valFromOption(domElement).scrollTo({
        top: 0,
        behavior: "smooth"
      });
      return;
    }
  };
  let match$2 = styleProps$1(match[0], match$1[0]);
  return JsxRuntime.jsx(Touchable.make, {
    children: JsxRuntime.jsx("div", {
      children: JsxRuntime.jsx(Svg.make, {
        children: JsxRuntime.jsx(Svg.Path.make, {
          d: "M 11.236 4.018 L 16.683 9.464 L 1.97 9.464 C 1.559 9.464 1.301 9.91 1.508 10.267 C 1.603 10.433 1.779 10.535 1.97 10.535 L 16.799 10.535 L 11.352 15.981 C 11.06 16.272 11.194 16.768 11.592 16.876 C 11.775 16.926 11.973 16.873 12.108 16.738 L 18.408 10.436 C 18.618 10.227 18.618 9.887 18.408 9.679 L 11.991 3.263 C 11.784 3.053 11.444 3.053 11.236 3.263 C 11.027 3.47 11.027 3.81 11.236 4.018 Z",
          fill: "#25243a",
          transform: "rotate(270 10.5 11.5)"
        }),
        width: "18",
        height: "18",
        viewBox: "0 0 18 16",
        style: {
          paddingTop: "4px"
        }
      }),
      className: match$2.className,
      style: match$2.style
    }),
    ariaProps: buttonProps,
    onPress: handleButtonPress
  });
}
let make$1 = React.memo(ResourceListPagination$ResourceListPaginationScrollToTopButton);
let separatorIconElement = JsxRuntime.jsx(Svg.make, {
  children: JsxRuntime.jsx(Svg.Path.make, {
    d: "M4,11 C4.55228475,11 5,10.5522847 5,10 C5,9.44771525 4.55228475,9 4,9 C3.44771525,9 3,9.44771525 3,10 C3,10.5522847 3.44771525,11 4,11 Z M10,11 C10.5522847,11 11,10.5522847 11,10 C11,9.44771525 10.5522847,9 10,9 C9.44771525,9 9,9.44771525 9,10 C9,10.5522847 9.44771525,11 10,11 Z M16,11 C16.5522847,11 17,10.5522847 17,10 C17,9.44771525 16.5522847,9 16,9 C15.4477153,9 15,9.44771525 15,10 C15,10.5522847 15.4477153,11 16,11 Z",
    fill: "#797885"
  }),
  width: "20",
  height: "20",
  viewBox: "0 0 20 20"
});
function ResourceListPagination(props) {
  let tableBodyRef = props.tableBodyRef;
  let onPress = props.onRequestPaginate;
  let lastDirection = props.lastDirection;
  let loading = props.loading;
  let totalPages = props.totalPages;
  let currentPage = props.currentPage;
  let match = {
    className: "backgroundColor-x17suf5r borderTopColor-x1eit1tb borderTopStyle-x13fuv20 borderTopWidth-x178xt8z alignItems-x6s0dn4 bottom-x1ey2m1c display-x78zum5 flexDirection-x1q0g3np height-xng8ra justifyContent-xl56j7k paddingInline-x17qtykl position-x7wzq59 zIndex-xhtitgo",
    "data-style-src": "wino-gc:src/core/ResourceListPagination.res.js:295"
  };
  let match$1 = {
    className: "transform-x18ea9l4 alignItems-x6s0dn4 display-x78zum5 gap-x1jnr06f margin-x1bpp3o7",
    "data-style-src": "wino-gc:src/core/ResourceListPagination.res.js:310"
  };
  React.useEffect(() => {
    if (!loading) {
      let domElement = ReactDomElement.fromRef(tableBodyRef);
      if (domElement !== undefined) {
        Primitive_option.valFromOption(domElement).scrollTo({
          top: 0,
          behavior: "smooth"
        });
      }
    }
  }, [loading, currentPage]);
  let notFirstPages = currentPage > 1 && totalPages !== 2;
  let notLastPages = currentPage < (totalPages - 1 | 0);
  return JsxRuntime.jsxs("div", {
    children: [JsxRuntime.jsx(ResourceListPagination$ResourceListPaginationSummary, {
      currentPage: currentPage,
      totalCount: props.totalCount,
      loading: loading,
      itemsPerPage: props.itemsPerPage
    }), JsxRuntime.jsxs("div", {
      children: [JsxRuntime.jsx(make, {
        loading: loading,
        currentPage: currentPage,
        totalPages: totalPages,
        action: "Prev",
        onPress: onPress
      }), JsxRuntime.jsx(make, {
        loading: loading,
        currentPage: currentPage,
        totalPages: totalPages,
        action: "First",
        onPress: onPress
      }), isForwardDirection(lastDirection) && (notLastPages || totalPages === 1) || !isForwardDirection(lastDirection) && currentPage < 3 ? JsxRuntime.jsxs(JsxRuntime.Fragment, {
        children: [currentPage > 2 ? separatorIconElement : null, notFirstPages ? JsxRuntime.jsx(make, {
          loading: loading,
          currentPage: currentPage,
          totalPages: totalPages,
          children: currentPage,
          onPress: onPress
        }) : null, totalPages !== 2 && notLastPages ? JsxRuntime.jsx(make, {
          loading: loading,
          currentPage: currentPage,
          totalPages: totalPages,
          action: "Next",
          children: currentPage + 1 | 0,
          onPress: onPress
        }) : null, currentPage !== 2 && currentPage < (totalPages - 2 | 0) ? JsxRuntime.jsx(make, {
          loading: loading,
          currentPage: currentPage,
          totalPages: totalPages,
          action: "NextNext",
          children: currentPage + 2 | 0,
          onPress: onPress
        }) : null, currentPage !== totalPages && currentPage < (totalPages - 3 | 0) ? separatorIconElement : null]
      }) : JsxRuntime.jsxs(JsxRuntime.Fragment, {
        children: [currentPage > 4 && totalPages >= 4 ? separatorIconElement : null, currentPage !== 2 && currentPage > 3 && totalPages > 3 && (currentPage < (totalPages - 1 | 0) || currentPage === totalPages) ? JsxRuntime.jsx(make, {
          loading: loading,
          currentPage: currentPage,
          totalPages: totalPages,
          action: "PrevPrev",
          children: currentPage - 2 | 0,
          onPress: onPress
        }) : null, notFirstPages && (totalPages > 3 || currentPage === totalPages) ? JsxRuntime.jsx(make, {
          loading: loading,
          currentPage: currentPage,
          totalPages: totalPages,
          action: "Prev",
          children: currentPage - 1 | 0,
          onPress: onPress
        }) : null, notFirstPages && currentPage !== totalPages ? JsxRuntime.jsx(make, {
          loading: loading,
          currentPage: currentPage,
          totalPages: totalPages,
          children: currentPage,
          onPress: onPress
        }) : null, currentPage !== totalPages && currentPage < (totalPages - 1 | 0) ? separatorIconElement : null]
      }), totalPages !== 1 ? JsxRuntime.jsx(make, {
        loading: loading,
        currentPage: currentPage,
        totalPages: totalPages,
        action: "Last",
        onPress: onPress
      }) : null, JsxRuntime.jsx(make, {
        loading: loading,
        currentPage: currentPage,
        totalPages: totalPages,
        action: "Next",
        onPress: onPress
      })],
      className: match$1.className,
      style: match$1.style
    }), JsxRuntime.jsx(make$1, {
      tableBodyRef: tableBodyRef
    })],
    className: match.className,
    style: match.style
  });
}
let make$2 = React.memo(ResourceListPagination);
export { make$2 as make };
/* styles Not a pure module */